/**
 * BreadcrumbSchema — invisible JSON-LD BreadcrumbList for crawlers.
 *
 * Does NOT render visible UI. Drop into any page to expose crawlable
 * hierarchy to search engines and AI indexers.
 *
 * Usage:
 *   <BreadcrumbSchema items={[
 *     { name: 'Home', path: '/' },
 *     { name: 'Guides', path: '/guides' },
 *     { name: 'Heartfelt Message to Mom', path: '/heartfelt-message-to-mom' },
 *   ]} />
 */

const SITE_ORIGIN = 'https://say-it-now.app';

export interface BreadcrumbItem {
  name: string;
  /** Relative path beginning with "/". The full URL is composed against say-it-now.app. */
  path: string;
}

interface BreadcrumbSchemaProps {
  items: BreadcrumbItem[];
}

export function BreadcrumbSchema({ items }: BreadcrumbSchemaProps) {
  if (!items || items.length === 0) return null;

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: `${SITE_ORIGIN}${item.path}`,
    })),
  };

  return (
    <script
      type="application/ld+json"
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
    />
  );
}
